<template>
    <div class="pn-duc-deg-fix-panel" :class="cursorClass" @click="toggleEditDialog">
        <div v-if="pnCount >= 0" class="pn-count-info" :class="{ hazard: pnHazard }">
            <img
                v-b-tooltip.hover
                class="score-hazard-icon"
                :title="$uiUtils.formatPnHazardMessage(pnCount)"
                src="/static/svg/Hazard_PN_white.svg"
                alt=""
            />

            <span class="pn-value">{{ pnText }}</span>
        </div>

        <span class="duc" :class="{ hazard: hasDuc }">{{ $translate('duc') }}</span>

        <span class="deg" :class="{ hazard: isDeg }">{{ $translate('deg') }}</span>

        <div class="actions">
            <changed-by-user v-if="isChanged" />

            <b-button v-if="!isComparePage" variant="transparent" class="edit-btn">
                <i class="fa fa-pencil" />
            </b-button>
        </div>

        <pn-duc-deg-dialog
            v-if="showEditDialog"
            :well="well"
            :pn-count="pnCount"
            :pn-count-time="pnCountTime"
            :has-duc="hasDuc"
            :is-degenerated="isDeg"
            @hide="toggleEditDialog(true)"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PnDucDegDialog from './PnDucDegDialog'
import ChangedByUser from './ChangedByUser'
import { TREATMENT_PAGE_VIEWS } from '../../../business/const'

export default {
    name: 'PnDucDegFixPanel',
    components: {
        ChangedByUser,
        PnDucDegDialog
    },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        showEditDialog: false
    }),
    computed: {
        ...mapState({
            videoPlaybackReady: state => state.timelapse.videoPlaybackReady,
            shareDialogOpened: state => state.timelapse.shareDialogOpened,
            currentView: state => state.navigation.currentView,
            shareToPatientDialogOpened: state => state.timelapse.shareToPatientDialogOpened
        }),
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnCountTime: 'timelapse/getPnCountTime',
            getPnHazard: 'timelapse/getPnHazard',
            getPnText: 'timelapse/getPnText',
            checkDucsHazard: 'timelapse/checkDucsHazard',
            checkDegHazard: 'timelapse/checkDegeneratedOocyteHazard'
        }),
        pnCount() {
            return this.getPnCount(this.well)
        },
        pnCountTime() {
            return this.getPnCountTime(this.well)
        },
        pnHazard() {
            return this.getPnHazard(this.well)
        },
        pnText() {
            return this.getPnText(this.well)
        },
        hasDuc() {
            return this.checkDucsHazard(this.well)
        },
        isDeg() {
            return this.checkDegHazard(this.well)
        },
        isChanged() {
            const { inferenceOverridingData: overriding } = this.well

            const isPnChanged = overriding.hasOwnProperty('pnCount')
            const isDucChanged = overriding.hasOwnProperty('duc')
            const isDegChanged = overriding.hasOwnProperty('degeneratedOocyte')

            return isPnChanged || isDucChanged || isDegChanged
        },
        isComparePage() {
            return (
                this.$route.name === this.$paths.TREATMENTS &&
                this.currentView === TREATMENT_PAGE_VIEWS.COMPARE_WELLS
            )
        },
        cursorClass() {
            return !this.videoPlaybackReady
                ? 'progress'
                : this.isComparePage
                ? 'default-cursor'
                : 'pointer'
        }
    },
    watch: {
        shareDialogOpened(isOpen) {
            if (isOpen) {
                this.showEditDialog = false
            }
        },
        shareToPatientDialogOpened(isOpen) {
            if (isOpen) {
                this.showEditDialog = false
            }
        }
    },
    methods: {
        toggleEditDialog(isForce = false) {
            if (this.isComparePage) {
                return
            }
            if (!this.videoPlaybackReady && isForce !== true) {
                return
            }
            if (!this.showEditDialog) {
                this.$store.commit('timelapse/shareDialogOpened', false)
                this.$store.commit('timelapse/shareToPatientDialogOpened', false)
            }
            this.showEditDialog = !this.showEditDialog
        }
    }
}
</script>

<style lang="scss" scoped>
.pn-duc-deg-fix-panel {
    position: relative;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    font-size: 14px;

    &.progress {
        cursor: progress;
        height: auto;
        line-height: normal;
        background-color: $dark-3;
    }
    &.pointer {
        cursor: pointer;
    }
    &.default-cursor {
        cursor: default;
    }

    .pn-count-info {
        display: flex;
        flex-wrap: nowrap;

        .pn-value {
            white-space: nowrap;
        }

        &.hazard {
            .score-hazard-icon {
                width: 20px;
                height: 20px;
                margin: 0 0.25rem;
            }
            .pn-value {
                color: $red;
            }
        }
        &:not(.hazard) {
            .score-hazard-icon {
                display: none;
            }
        }
    }

    .pn-count-info,
    .duc,
    .deg {
        margin-right: 1rem;
    }

    .duc,
    .deg {
        &.hazard {
            color: $red;
        }
    }

    .actions {
        display: flex;
        align-items: center;
        margin-left: auto;
        margin-right: 0.5rem;

        .changed-by-user {
            margin-right: 0.5rem;
        }
    }

    .pn-duc-deg-dialog {
        min-width: 100%;
        position: absolute;
        right: 0;
    }
}
</style>
